import { oz } from '@weft/utils';
import type { ZapiParam, ZapiParamsMap, ZapiPath } from '@weft/zapi-types';
import { PATH_ACCESS_LEVELS } from '@weft/zapi-types';
import { NEST_API_TAGS } from '../../api-tags';

const NOTIFICATION_ALERT_ID_PATH_PARAM = {
  name: 'notificationAlertId',
  location: 'path',
  schema: oz.string(),
  required: true,
} as const satisfies ZapiParam;

const UPDATE_NOTIFICATION_ALERT_STATUS_PATH_PARAMS = {
  [NOTIFICATION_ALERT_ID_PATH_PARAM.name]: NOTIFICATION_ALERT_ID_PATH_PARAM,
} as const satisfies ZapiParamsMap;

export const UPDATE_NOTIFICATION_ALERT_STATUS_PATH = {
  accessLevel: PATH_ACCESS_LEVELS.PRIVATE,
  route: '/notification-alert/{notificationAlertId}/status',
  pathParams:  UPDATE_NOTIFICATION_ALERT_STATUS_PATH_PARAMS,
  tags: NEST_API_TAGS.NOTIFICATION_ALERTS,
} satisfies ZapiPath;

export type UpdateNotificationAlertStatusPath = typeof UPDATE_NOTIFICATION_ALERT_STATUS_PATH;